export default __webpack_public_path__ + "static/media/services-personal.0d494c21.jpg";